import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import logo from "../../assets/logoo.png";
import base64Img from "../../assets/base64.js"

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#ef7f1a",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 24px",
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  logo: {
    width: "120px",
    filter: "brightness(0) invert(1)",
  },
  title: {
    fontWeight: "bold",
    marginLeft: "16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  userSection: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  avatar: {
    backgroundColor: "#fff",
    color: "#ef7f1a",
    fontWeight: "bold",
  },
  userName: {
    fontWeight: "500",
  },
  logoutBtn: {
    backgroundColor: "#fff",
    color: "#ef7f1a",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  badge: {
    backgroundColor: "#fff",
    color: "#ef7f1a",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "bold",
    marginLeft: "8px",
  },
}));

const SuperAdminNavBar = () => {
  const classes = useStyles();
  const history = useHistory();
  const [user] = useState(
    JSON.parse(localStorage.getItem("profile"))
  );

  const handleLogout = () => {
    localStorage.removeItem("profile");
    history.push("/login");
    window.location.reload();
  };

  const getInitials = (name) => {
    if (!name) return "SA";
    const names = name.split(" ");
    return names
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };


  if (!user) return null;

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Box className={classes.logoSection}>
          <img
            src={base64Img}
            alt="Logo"
            style={{ width: "120px", height: "auto" }}
          />

          <Typography variant="h6" className={classes.title}>
            <SupervisorAccountIcon />
            Subscription Management
          </Typography>
        </Box>

        <Box className={classes.userSection}>
          <Avatar className={classes.avatar}>
            {getInitials(user?.result?.name)}
          </Avatar>
          <Typography className={classes.userName}>
            {user?.result?.name || "Super Admin"}
          </Typography>
          <Button
            variant="contained"
            className={classes.logoutBtn}
            startIcon={<ExitToAppIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default SuperAdminNavBar;

